var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('overflow: hidden; position: relative; background: ' + _vm.Colors.MenuTextColor + ';'+ (_vm.vertical?' width: 1px; min-height: 100%; max-height: 100%;':' width: auto; max-width: 100%; height: 1px;'))})
}
var staticRenderFns = []

export { render, staticRenderFns }